import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AdvancePaymentModel } from './advancePayment.model';
import { EventEmitter } from '@angular/core';
import { Output, AfterContentChecked } from '@angular/core';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { UntypedFormControl } from '@angular/forms';
import { map, Observable } from "rxjs";
import { AdvancedPaymentLineModel } from './advancedPaymentline.model';
import { AdvancedPaymentTaxModel } from './advancedPaymentTax.model';
import { InvoiceTaxesModel } from '../../invoice/preinvoice/invoicetaxes.model';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { ConceptModel } from '../../concept/concept/concept.model';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { ActualSelected, Utils } from '../../../shared/utils';
import { consts, PAY_METHODS } from '../../../consts';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { PaymentCardModel } from '../../finanzas/paymentcard/paymentcard.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { AdvancePaymentFormItemComponent } from './advancePayment-form-item.component';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-advancepayment-form',
    templateUrl: './advancePayment-form.component.html',
    styleUrls: ['./advancePayment.component.css'],
    standalone: false
})

export class AdvancePaymentFormComponent implements OnInit, AfterContentChecked {
  @Input() advancePayment: AdvancePaymentModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;
  @Input() accountsAndTaxes: AccountsAndTaxesModel;
  @Input() concepts: ConceptModel[];
  @Input() bankAccounts: BankAccountModel[] = [];
  @Input() paymentCards: PaymentCardModel[] = [];

  ready: boolean = false;
  advancePaymentForm: UntypedFormControl;
  filteredContacts: Observable<ContactModel[]>;
  contactList: ContactModel[] = [];

  aux: number;
  result: number;
  taxes: Array<AdvancedPaymentTaxModel>;
  taxesView: string[] = [];

  taxesInvoice: InvoiceTaxesModel[] = [];
  taxesToTheView: string[] = [];

  payMethods = [
    consts.TYPEPAY_CASH,
    consts.TYPEPAY_CREDITCARD_PAY,
    consts.TYPE_DEBITCARD,
    consts.TYPEPAY_DEBITENTRY,
    consts.TYPEPAY_BANKTRANSFERENCE,
    consts.TYPEPAY_CONFIRMING,
    consts.TYPEPAY_PAGARES,
    consts.TYPE_SOCIO,
  ];

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];

  public saved: boolean = false;

  public get payMethodsOptions(): Option[] {
    return this.payMethods.map(method => ({ label: method, value: method }));
  }

  constructor(
    public snackBar: MatSnackBar,
    private contactService: ContactService,
    private taxCalculator: TaxCalculator,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) { }

  filterContacts(val) {
    const self = this;
    for (const contact of this.contactList) {
      if (contact.companyName == val) {
        self.advancePayment.providerUid = contact.uid;
      }
    }
    const normalizedValue = this.normalize(val);
    return val ? this.contactList.filter(contact => this.normalize(contact.companyName).includes(normalizedValue)) : this.contactList;
  }

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }

  ngOnInit() {
    this.efectivoService.list()
      .then(listadoEfectivos => {
        this.efectivoList = listadoEfectivos
      })

    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });

    this.contactList = [];
    this.contactService.getListProviders().then(response => {
      this.contactList = response;
      this.ready = true;
      this.advancePaymentForm = new UntypedFormControl();
      this.filteredContacts = this.advancePaymentForm.valueChanges
        .pipe(
          map(contact => contact && typeof contact === 'object' ? contact.companyName : contact),
          map(name => this.filterContacts(name))
        );
      this.ready = true;
    });
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  save(advancePayment) {
    advancePayment.isInvoice = false;

    advancePayment.fiscalYear = parseInt(ActualSelected.yearSelected);
    advancePayment.activityUid = ActualSelected.activitySelected;

    let noError = true;

    if (!Utils.DateIsInFiscalYear(advancePayment.date)) {
      noError = false;
      this.displayInfo("La fecha y el año fiscal seleccionado, no son el mismo.");
    }

    if (advancePayment.typePay == null || advancePayment.typePay == "") {
      noError = false;
      this.displayInfo("El tipo de pago debe estar especificado.");
    } else {
      if ((advancePayment.typePay == "Transferencia bancaria" || advancePayment.typePay === "Cargo en cuenta"
        || advancePayment.typePay === consts.TYPEPAY_CONFIRMING || advancePayment.typePay === consts.TYPEPAY_PAGARES) &&
        (advancePayment.typePayBankAccount == null || advancePayment.typePayBankAccount == "")) {
        noError = false;
        this.displayInfo("Debe especificar la cuenta bancaria.");
      }
      if (advancePayment.typePay == "Tarjeta de crédito" && (advancePayment.typePayBankAccount == null || advancePayment.typePayBankAccount == "")) {
        noError = false;
        this.displayInfo("Debe especificar la tarjeta de crédito.");
      }
    }

    if (advancePayment.typePay !== consts.TYPEPAY_CASH) {
      advancePayment.efectivoId = null;
    }

    if (advancePayment.typePay !== consts.TYPE_SOCIO) {
      advancePayment.partnersId = 0;
    }

    if (noError) {
      this.preventNullOrEmptyValues(advancePayment);
      this.onSave.emit(advancePayment)
    }
  }

  preventNullOrEmptyValues(advancePayment) {
    for (let i = 0; i < advancePayment.advancedPaymentLines.length; i++) {

      if (advancePayment.advancedPaymentLines[i].discount == null || advancePayment.advancedPaymentLines[i].discount === '') {
        advancePayment.advancedPaymentLines[i].discount = 0;
      }
      if (advancePayment.advancedPaymentLines[i].quantity == null || advancePayment.advancedPaymentLines[i].quantity === '') {
        advancePayment.advancedPaymentLines[i].quantity = 0;
      }
      if (advancePayment.advancedPaymentLines[i].unityAmount == null || advancePayment.advancedPaymentLines[i].unityAmount === '') {
        advancePayment.advancedPaymentLines[i].unityAmount = 0;
      }

    }
  }

  // addInvoiceLine() {
  //   this.advancePayment.advancedPaymentLines.push(new AdvancedPaymentLineModel());

  // }

  // removeInvoiceLine(invoiceLine) {
  //   this.advancePayment.advancedPaymentLines.splice(this.advancePayment.advancedPaymentLines.indexOf(invoiceLine), 1);
  //   if (this.advancePayment.advancedPaymentLines.length == 0) {
  //     this.advancePayment.advancedPaymentLines.push(new AdvancedPaymentLineModel());
  //   }
  // }

  // calcularSubtotal() {
  //   return this.taxCalculator.calcularSubtotal(this.advancePayment);
  // }

  // calcularTotal() {
  //   this.advancePayment.total = this.taxCalculator.calcularTotal(this.advancePayment);
  //   return this.advancePayment.total;
  // }

  // impuestos() {
  //   this.taxesToTheView = this.taxCalculator.impuestos(this.advancePayment, this.result, this.aux, this.taxesView, this.taxesInvoice, this.taxesToTheView);
  //   return this.taxesToTheView;
  // }


  addInvoiceLine() {
    let line = new AdvancedPaymentLineModel();

    const dialog = this.dialog.open(AdvancePaymentFormItemComponent, {
      width: '540px', maxWidth: '96vw', maxHeight: '90vh',
      data: { taxes: this.accountsAndTaxes.taxes, item: line },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        line = result.item;
        this.advancePayment.advancedPaymentLines.push(line);
      }
      this.cdr.detectChanges();
    });

  }

  removeInvoiceLine(invoiceLine) {
    this.advancePayment.advancedPaymentLines.splice(this.advancePayment.advancedPaymentLines.indexOf(invoiceLine), 1);
    if (this.advancePayment.advancedPaymentLines.length == 0) {
      this.advancePayment.advancedPaymentLines.push(new AdvancedPaymentLineModel());
    }
  }

  calcularSubtotal() {
    return this.taxCalculator.calcularSubtotal(this.advancePayment);
  }

  calcularTotal() {
    this.advancePayment.total = this.taxCalculator.calcularTotal(this.advancePayment);
    return this.advancePayment.total;
  }

  impuestos(): string[] {
    const taxesView: string[] = [];
    const taxesInvoice: any[] = [];
    return this.taxCalculator.impuestos(this.advancePayment, undefined, undefined, taxesView, taxesInvoice, []);
  }

  ngAfterContentChecked() {
    // Tax breakdown computed via stateless impuestos() call from template
  }


  changeToggle(element, other) {
    this.advancePayment[other] = (this.advancePayment[element]);
  }

  toggleEditMode(index) {
    const dialog = this.dialog.open(AdvancePaymentFormItemComponent, {
      width: '540px', maxWidth: '96vw', maxHeight: '90vh',
      data: { taxes: this.accountsAndTaxes.taxes, item: this.advancePayment.advancedPaymentLines[index] },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.advancePayment.advancedPaymentLines[index] = result.item;
      } else {

      }
      this.cdr.detectChanges();
    });

  }

  calcularTotalesLinea(invoiceLine) {
    invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
    return invoiceLine.totalLine;
  }

  saveLine(index, item) {
    this.advancePayment.advancedPaymentLines[index] = item;
  }

  getStrTaxes(taxes: any[]) {
    return taxes.map(tax => tax.name).join(', ');
  }

  public trackByIndex(i: number) { return i; }

}
